import { Component, OnDestroy, OnInit } from '@angular/core';
// import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Observable, Subscription } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../_services';
import { CongratsEditModalComponent } from './congrats-edit-modal/congrats-edit-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-congrats',
  templateUrl: './congrats.component.html',
  styleUrls: ['./congrats.component.scss']
})
export class CongratsComponent implements OnInit, OnDestroy {
  language: any;
  title: string;
  details:string;
  CongratsImages:any[] = [];
  CongratsCategories$;

  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

 

  constructor(private HospitalService: HospitalService,private translationService: TranslationService,
    private route: ActivatedRoute,private router: Router) { }

  ngOnInit(): void {
  this.language = this.translationService.getSelectedLanguage();
   const sb = this.HospitalService.GetCongratsImages('').subscribe(res => {
      if (res.data != null && res.isSuccess)
      {
        this.CongratsImages = res.data;
      }
    });
    this.subscriptions.push(sb);
    this.LoadAllCongratsCategories();
    this.isLoading$ = this.HospitalService.isLoading$;

  }
  LoadAllCongratsCategories() {
    this.CongratsCategories$ = this.HospitalService.GetCongratsCategories();
  }
  OnChangeCongratsCategory(event) {
    let CategoryId = event.target.options[event.target.options.selectedIndex].value;
    const sb = this.HospitalService.GetCongratsImages(CategoryId).subscribe(res => {
      if (res.data != null && res.isSuccess)
      {
        this.CongratsImages = res.data;
      }
    });
    this.subscriptions.push(sb);
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  openDialog(imagePath) {
    sessionStorage.setItem('ImagePath',imagePath);
    this.router.navigate(['/card-edit' ], { relativeTo: this.route });
  }

  // openDialog(imagePath) {
  //   const modalRef = this.modalService.open(CongratsEditModalComponent);
  //   if (this.language == 'en')
  //   {
  //     modalRef.componentInstance.data = {image: imagePath}
  //   }
  //   else
  //   {
  //     modalRef.componentInstance.data = { image: imagePath}
  //   }
  // }
  // openDialog(Image) {
  //   const modalRef = this.modalService.open(CongratsEditModalComponent);
  //   if (this.language == 'en')
  //   {
  //     modalRef.componentInstance.data = {image: Image.imagePath}
  //   }
  //   else
  //   {
  //     modalRef.componentInstance.data = { image: Image.imagePath}
  //   }
   
  // }
}
